import { v2Request } from "../helpers/request";

const sendAppointment = (payload) => {
  return v2Request("/appointments", {
    method: "POST",
    body: JSON.stringify(payload),
  });
};
const sendBulkAppointments = (payload) => {
  return v2Request("/appointments/bulk", {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

const editAppointment = (payload) => {
  return v2Request("/appointments/editappt", {
    body: JSON.stringify(payload),
    method: "PUT",
  });
};

const getRequirementStatus = () => {
  return v2Request("/appointments/requirements/status");
};

const getRepStatusForAppt = (repId) => {
  return v2Request(`/appointments/rep-status/${repId}`);
};

const confirmation = (payload) => {
  return v2Request("/appointments/final", {
    body: JSON.stringify(payload),
    method: "POST",
  });
};

const isAppointmentCurrent = (payload) => {
  return v2Request("/appointments/is-current", {
    body: JSON.stringify(payload),
    method: "POST",
  });
};

const file = (payload) => {
  return v2Request("/files/appointment/link", {
    body: JSON.stringify(payload),
    method: "POST",
  });
};

const bookAppt = async (payload) => {
  return v2Request("/appointments/booking", {
    body: JSON.stringify(payload),
    method: "PUT",
  });
};

const transferAppt = (payload) => {
  return v2Request("/appointments/transfer", {
    body: JSON.stringify(payload),
    method: "PUT",
  });
};

const cancelApptRep = (apptId) => {
  return v2Request(`/appointments/cancel/${apptId}`);
};

const getAllCalendarAppointments = () => {
  return v2Request(`/appointments/calendar`);
};

const getClientUpcomingAppointments = (query) => {
  return v2Request(`/appointments${query}`);
};

const getAppointmentsAvailable = () => {
  return v2Request(`/appointments/available`);
};

const getAppointment = (appointmentId) => {
  return v2Request(`/appointments/available/${appointmentId}`);
};

const getApptsClient = () => {
  return v2Request("/appointments/booked");
};

const files = () => {
  return v2Request("/files/offices/calendar");
};

const getDietaryData = () => {
  return v2Request("/appointments/diet");
};

const getBooked = () => {
  return v2Request("/appointments/booked");
};

const getRepBooked = () => {
  return v2Request("/appointments/booked");
};
const getRepUpcomingBooked = (page = 1) => {
  return v2Request(`/appointments/booked-upcoming?page=${page}`);
};
const getRepBookedPast = (payload) => {
  return v2Request("/appointments/booked-past", {
    body: JSON.stringify(payload),
    method: "POST",
  });
};
const getRepBookedSummary = () => {
  return v2Request("/appointments/booked-summary");
};
const getBookedAppointmentDetails = (id) => {
  return v2Request(`/appointments/booked/${id}`);
};

const getAppointmentDetails = (id, isRecurring) => {
  return v2Request(`/appointments/${id}?isRecurring=${isRecurring}`);
};

const deleteEventById = (data) => {
  return v2Request(`/appointments/delete/${data.id}`, {
    body: JSON.stringify(data),
    method: "DELETE",
  });
};

const getVirtualOptions = () => {
  return v2Request("/appointments/virtual/options");
};

const unsubscribeAllNotifications = (websocketConnection) => {
  if (websocketConnection !== null) {
    websocketConnection.close();
  }
};
const annotateAppointment = (payload) => {
  return v2Request("/appointments/annotations", {
    body: JSON.stringify(payload),
    method: "POST",
  });
};
export {
  sendAppointment,
  sendBulkAppointments,
  editAppointment,
  getApptsClient,
  transferAppt,
  files,
  getDietaryData,
  bookAppt,
  file,
  confirmation,
  getAllCalendarAppointments,
  getClientUpcomingAppointments,
  getAppointment,
  getAppointmentsAvailable,
  cancelApptRep,
  getRepBooked,
  getRepUpcomingBooked,
  getBooked,
  deleteEventById,
  unsubscribeAllNotifications,
  getVirtualOptions,
  getRequirementStatus,
  getBookedAppointmentDetails,
  isAppointmentCurrent,
  getRepStatusForAppt,
  getAppointmentDetails,
  getRepBookedPast,
  getRepBookedSummary,
  annotateAppointment,
};
